module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-xs no-margin no-padding tables-containter"
  }, [_c('adminPortalAnalyticsTableCard', {
    staticClass: "mb4",
    attrs: {
      "tableKey": 'activeTeacher',
      "title": 'Most Active Teachers',
      "analyticsMostActiveTeachers": _vm.analyticsMostActiveTeachers,
      "tooltip": _vm.active_teachers_tooltip
    }
  }), _vm._v(" "), _c('adminPortalAnalyticsTableCard', {
    staticClass: "mb4",
    attrs: {
      "tableKey": 'inactiveTeacher',
      "title": 'Inactive Teachers',
      "analyticsInactiveTeachers": _vm.analyticsInactiveTeachers,
      "tooltip": _vm.inactive_teachers_tooltip
    }
  }), _vm._v(" "), _c('adminPortalAnalyticsTableCard', {
    staticClass: "mb4",
    attrs: {
      "tableKey": 'recentTopicsUsed',
      "title": 'Recent Topics Used',
      "analyticsRecentTopicsUsed": _vm.analyticsRecentTopicsUsed,
      "tooltip": _vm.recent_topics_used_tooltip
    }
  }), _vm._v(" "), _c('adminPortalAnalyticsTableCard', {
    staticClass: "mb4",
    attrs: {
      "tableKey": 'topUniversePortfolios',
      "title": 'Top Universe Portfolios',
      "analyticsTopUniversePortfolios": _vm.analyticsTopUniversePortfolios,
      "tooltip": _vm.top_universe_portfolios_tooltip
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-28b6a513!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/adminPortalAnalyticsTables.vue
// module id = 2146
// module chunks = 61